import axios from "axios";
 
import service from "./index";
import { setAddressList, setCountryStates, setRewardsPoints, setStateCity, setUserProfile, uploadImageFailure, uploadImageRequest, uploadImageSuccess } from "../reducers/common";
export const uploadImageAction = (apiData) => async (dispatch) => {
  dispatch(uploadImageRequest());
  return new Promise(async (resolve, reject) => {
    try {
      const res = await axios.post(`${process.env.REACT_APP_BASE_URL}User/UploadFile`,apiData);
      resolve(res?.data);
      dispatch(uploadImageSuccess(res?.data.data.url));
    } catch (err) {
      dispatch(uploadImageFailure());
      reject(err?.data);
    }
  });
};

export const getUserProfile = (apiData) => async (dispatch) => {
  // dispatch(uploadImageRequest());
  return new Promise(async (resolve, reject) => {
    try {
      const res = await service.get("/User/GetUserProfile");
      resolve(res?.data?.data);
      dispatch(setUserProfile(res?.data?.data));
    } catch (err) {
      // dispatch(uploadImageFailure());
      reject(err?.data);
    }
  });
};

export const updateUserProfile = (apiData) => async (dispatch) => {
  // dispatch(uploadImageRequest());
  return new Promise(async (resolve, reject) => {
    try {
      const res = await service.post("/User/UpdateUserProfile", apiData);
      resolve(res?.data);
      // dispatch(uploadImageSuccess(res?.data.data.url));
    } catch (err) {
      // dispatch(uploadImageFailure());
      reject(err?.data);
    }
  });
};

export const addNewAddress = (apiData) => async (dispatch) => {
  // dispatch(uploadImageRequest());
  return new Promise(async (resolve, reject) => {
    try {
      const res = await service.post("/Order/AddAddress", apiData);
      resolve(res?.data);
      // dispatch(uploadImageSuccess(res?.data.data.url));
    } catch (err) {
      // dispatch(uploadImageFailure());
      reject(err?.data);
    }
  });
};

export const getAddressByUserId = () => async (dispatch) => {
  let apiData = {}
  return new Promise(async (resolve, reject) => {
    try {
      const res = await service.get("/Order/GetUserAddress");
      resolve(res?.data);
      dispatch(setAddressList(res?.data));
    } catch (err) {
      reject(err?.data);
    }
  });
};

export const deleteAddressByUserId = (apiData) => async (dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await service.post("/Order/DeleteAddress", apiData);
      resolve(res?.data);
    } catch (err) {
      reject(err?.data);
    }
  });
};

export const editAddressById = (apiData) => async (dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await service.post("/Order/EditAddress", apiData);
      resolve(res?.data);
    } catch (err) {
      reject(err?.data);
    }
  });
};

export const getCountryStates = (apiData) => async (dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await service.post("/Address/GetAllStates", apiData);
      resolve(res?.data);
      setCountryStates(res?.data)
    } catch (err) {
      reject(err?.data);
    }
  });
};

export const getStateCity = (apiData) => async (dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await service.post("/Address/GetAllCities", apiData);
      resolve(res?.data);
      setStateCity(res?.data)
    } catch (err) {
      reject(err?.data);
    }
  });
};

export const contactUsSubmit = (apiData) => async (dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await service.post("/ContactUs/CreateContactUsUser", apiData);
      resolve(res?.data);
    } catch (err) {
      reject(err?.data);
    }
  });
};

export const applyCoupon = (apiData) => async (dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await service.post("/ContactUs/CreateContactUsUser", apiData);
      resolve(res?.data);
    } catch (err) {
      reject(err?.data);
    }
  });
};
export const getUserRewards = (apiData) => async (dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await service.post("Reward/GetRewardById", apiData);
      resolve(res?.data);
      dispatch(setRewardsPoints(res?.data?.data?.myRewardPoints));
    } catch (err) {
      reject(err?.data);
    }
  });
};

